import React, { useState } from 'react'
import './Scrolltotop.css'
import { IoIosArrowUp } from 'react-icons/io'
export default function Scrolltotop() {
  const [iconclass, seticonclass] = useState('go-top')
  document.addEventListener('scroll', () => {
    if (window.scrollY > 10) {
      seticonclass('go-top active')
    }
    else if (window.scrollY < 10) {
      seticonclass("go-top")
    }
  })
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <>
    <div className={iconclass} onClick={scrollToTop}>
        <IoIosArrowUp className='gotopicon'/>
    </div>
    </>
  )
}
